export default class TouchController {
  public direction: TouchDirection = TouchDirection.NONE;
  private prevTouchX = 0;
  private prevTouchY = 0;
  public touching = false;
  public dragging = false;

  /* touch starts */

  public touchesBegan(e: TouchEvent): void {
    if (e && e.targetTouches) {
      this.touching = true;
      const firstTouch = e.targetTouches[0];
      this.prevTouchX = firstTouch.clientX;
      this.prevTouchY = firstTouch.clientY;
    }
  }

  /* swipe gestures */

  public touchesMoved(e: TouchEvent): void {
    if (e && e.targetTouches) {
      this.dragging = true;
      const touch = e.targetTouches[0];
      const x = touch.clientX;
      const y = touch.clientY;
      const xDiff = this.prevTouchX - x;
      const yDiff = this.prevTouchY - y;
      const absXDiff = Math.abs(xDiff);
      const absYDiff = Math.abs(yDiff);
      const range = Math.abs(absXDiff - absYDiff);

      if (range < 60) {
        if (xDiff > 0 && yDiff > 0) {
          //diagonal up left swipe
          this.direction = TouchDirection.UP_LEFT;
        }

        if (xDiff < 0 && yDiff > 0) {
          //diagonal up right swipe
          this.direction = TouchDirection.UP_RIGHT;
        }

        if (xDiff > 0 && yDiff < 0) {
          //diagonal down left swipe
          this.direction = TouchDirection.DOWN_LEFT;
        }

        if (xDiff < 0 && yDiff < 0) {
          //diagonal down right swipe
          this.direction = TouchDirection.DOWN_RIGHT;
        }

        return;
      }
      if (absXDiff > absYDiff) {
        if (xDiff > 0) {
          //left swipe
          this.direction = TouchDirection.LEFT;
        } else {
          //right swipe
          this.direction = TouchDirection.RIGHT;
        }
      } else {
        if (yDiff > 0) {
          //up swipe
          this.direction = TouchDirection.UP;
        } else {
          //down swipe
          this.direction = TouchDirection.DOWN;
        }
      }
    }
  }

  /* touch canceled */

  public touchesCanceled(_e: unknown): void {
    this.endTouch();
  }

  /* touch ended */

  public touchesEnded(_e: unknown): void {
    this.endTouch();
  }

  private endTouch(): void {
    this.prevTouchX = 0;
    this.prevTouchY = 0;
    this.touching = false;
    this.dragging = false;
    this.direction = TouchDirection.NONE;
  }
}

export enum TouchDirection {
  UP,
  DOWN,
  RIGHT,
  LEFT,
  UP_LEFT,
  UP_RIGHT,
  DOWN_LEFT,
  DOWN_RIGHT,
  NONE,
}
